import { flowRight, map, toString } from 'lodash';
import { getContentText } from '@wix/communities-universal/dist/src/services/editor-content-text';
import { getRichContentText } from './get-rich-content-text';
import { isRichContent } from './is-rich-content';
import hashtagRegexes from './hashtag-regexes';
const contentToText = (content) => {
    if (isRichContent(content)) {
        return getRichContentText(content, ' ');
    }
    return getContentText(content);
};
const extractHashtags = (text) => {
    if (!text || !text.match(hashtagRegexes.hashSigns)) {
        return [];
    }
    const tags = [];
    // eslint-disable-next-line max-params
    text.replace(hashtagRegexes.validHashtag, (match, before, hash, hashText, offset, chunk) => {
        const after = chunk.slice(offset + match.length);
        if (after.match(hashtagRegexes.endHashtagMatch)) {
            return;
        }
        const startPosition = offset + before.length;
        const endPosition = startPosition + hashText.length + 1;
        tags.push({
            hashtag: hashText,
            indices: [startPosition, endPosition],
        });
    });
    return tags;
};
const mapHashtags = (hashtags) => map(hashtags, (hashtagData) => hashtagData.hashtag);
const mapToLowerCase = (hashtags) => map(hashtags, (hashtag) => hashtag.toLowerCase());
export const extractHashtagsFromText = flowRight(mapToLowerCase, mapHashtags, extractHashtags, toString);
export const extractHashtagsFromContent = flowRight(mapToLowerCase, mapHashtags, extractHashtags, contentToText);
//# sourceMappingURL=hashtag-utils.js.map